import { render } from "./ThankYouContent.vue?vue&type=template&id=845c2504"
import script from "./ThankYouContent.vue?vue&type=script&lang=js"
export * from "./ThankYouContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__